module.exports = __webpack_public_path__ + "img/replay_task.40e838b2.svg";